import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { StickyNote } from "@/components/Notebook";
import { useLang } from "@/i18n";

/**
 * Premium teaser inviting visitors to explore the full methodology.
 * Wide, editorial layout with generous breathing room. Drops into any
 * landing page above the final CTA.
 */
export const MethodologyTeaser = ({ testId = "methodology-teaser" }) => {
  const { t, l } = useLang();
  return (
    <section
      className="relative z-10 py-24 md:py-32 bg-paper-deep/40 border-y border-ink/10"
      data-testid={testId}
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal>
          <div
            className="relative bg-paper border border-ink/12 shadow-[6px_12px_44px_rgba(27,27,24,0.10)] px-6 sm:px-10 md:px-14 lg:px-20 py-14 md:py-18 lg:py-24"
            data-testid={`${testId}-card`}
          >
            {/* Sticky note as an absolute-positioned accent to free horizontal space */}
            <StickyNote
              color="#E7DDC8"
              rotate={-7}
              className="hidden md:inline-block absolute -top-6 lg:-top-8 left-8 md:left-12 z-10"
            >
              {t("methodology_teaser.sticky")}
            </StickyNote>

            <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-end">
              <div className="lg:col-span-8 xl:col-span-9">
                <p className="font-body text-xs uppercase tracking-[0.24em] text-terracotta mb-6">
                  {t("methodology_teaser.eyebrow")}
                </p>
                <h3 className="font-serif text-3xl md:text-4xl lg:text-[3rem] leading-[1.08] tracking-tight text-ink max-w-[26ch]">
                  {t("methodology_teaser.h1_a")}{" "}
                  <span className="italic text-terracotta/95">
                    {t("methodology_teaser.h1_emphasis")}
                  </span>
                </h3>
              </div>

              <div className="lg:col-span-4 xl:col-span-3 flex lg:justify-end">
                <Link
                  to={l("/how-we-work")}
                  data-testid={`${testId}-cta`}
                  className="group sm:whitespace-nowrap inline-flex items-center gap-3 bg-ink text-paper px-8 py-5 font-body text-xs uppercase tracking-[0.22em] hover:bg-terracotta transition-colors duration-300"
                >
                  {t("methodology_teaser.cta")}
                  <span className="transition-transform duration-300 group-hover:translate-x-1 max-md:animate-nudge-x">
                    &rarr;
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
